module.exports = __webpack_public_path__ + "static/media/shutterstock_707617954.2bce9469.jpg";